import defaultClient from '@src/api/clients/default';

const URL = (path) => {
  return `dashboard/ad-summary/${path}/`;
};

export function fetchAdSummaryByAd(payload = {}) {
  return defaultClient.request({
    url: URL('ad'),
    payload,
  });
}

export function fetchAdSummaryByTheme(payload = {}) {
  return defaultClient.request({
    url: URL('theme'),
    payload,
  });
}

export function fetchAdSummaryBySubtheme(payload = {}) {
  return defaultClient.request({
    url: URL('subtheme'),
    payload,
  });
}

export function fetchAdSummaryFilterOptions(payload = {}) {
  return defaultClient.request({
    url: URL('filter-options'),
    payload,
  });
}

export function fetchAdSummaryByAdWeekly(payload = {}) {
  return defaultClient.request({
    url: URL('ad-weekly'),
    payload,
  });
}

export function pauseAdSummaryAd(payload = {}) {
  return defaultClient.request({
    url: URL('pause-ad'),
    method: 'POST',
    payload,
  });
}

export function fetchAdPreview(payload = {}) {
  return defaultClient.request({
    url: URL('preview'),
    payload,
  });
}

export function fetchPruningQueue(payload = {}) {
  return defaultClient.request({
    url: URL('pruning-queue'),
    payload,
  });
}

export function approvePruneFlag(payload = {}) {
  return defaultClient.request({
    url: URL('approve-prune'),
    method: 'POST',
    payload,
  });
}

export function dismissPruneFlag(payload = {}) {
  return defaultClient.request({
    url: URL('dismiss-prune'),
    method: 'POST',
    payload,
  });
}
